/**
 * Client-side cache for records some S-suite routers don't expose a
 * list/read-back endpoint for at all — S04 home care is write-only end to
 * end (no GET routes whatsoever), S06 has no `GET /runs` list, S05 has no
 * `GET /sessions` list, and S08 only exposes an *overdue* appeals queue, not
 * the full docket. Everything stored here is the verbatim response of a
 * real API call (a POST that returns the created/updated record) — this is
 * a browser-local index over genuine data, never fabricated content. See
 * this app's build report for exactly which screens rely on it and why.
 *
 * Namespaced per persona so switching dev personas doesn't mix caseloads.
 */
const PREFIX = 'asp.cache.';

export function loadList<T extends { id: string }>(key: string): T[] {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    return raw ? (JSON.parse(raw) as T[]) : [];
  } catch {
    return [];
  }
}

/** Insert or update by id, most-recent first, capped so the cache can't grow unbounded. */
export function upsertList<T extends { id: string }>(key: string, item: T): T[] {
  const list = loadList<T>(key);
  const idx = list.findIndex((x) => x.id === item.id);
  if (idx >= 0) list[idx] = item;
  else list.unshift(item);
  const trimmed = list.slice(0, 200);
  localStorage.setItem(PREFIX + key, JSON.stringify(trimmed));
  return trimmed;
}
